// LogoMark — renders a clean logo by routing it through the backend's server-side
// processor which strips the white background and (if dark) inverts to white-on-transparent.
// Single round-trip, no client-side canvas, no CORS pain.
export default function LogoMark({ src, dark = false, className = "", alt = "Happy Retreats" }) {
  if (!src) return null;
  const BACKEND = process.env.REACT_APP_BACKEND_URL;
  const isAlreadyProcessed = src.includes("/api/asset-logo");
  const processedUrl = isAlreadyProcessed
    ? src
    : `${BACKEND}/api/asset-logo?dark=${dark ? "true" : "false"}&v=2&url=${encodeURIComponent(src)}`;
  return <img src={processedUrl} alt={alt} className={className} data-testid="logo-mark" />;
}
